import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import IconButton from 'aquilla/core/molecules/IconButton';
import LeftChevron from 'aquilla/icons/actions/LeftChevron';
import { useIsMobile } from '@stores/AppCommonData';
import { useRouter } from 'next/router';
import CbtVenueSelectionForm from './CbtVenueSelectionForm';

const PageWrapper = styled.div`
  grid-column: span 24;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  min-height: calc(100vh - 64px);
  background-color: var(--color-base-1);

  ${mediaQuery.uptoMobile} {
    background-color: var(--color-base-1);
    margin-left: -${Spacings.SPACING_4B};
    margin-right: -${Spacings.SPACING_4B};
    width: calc(100% + ${Spacings.SPACING_8B});
  }
`;

const HeaderBand = styled.div`
  width: 100%;
  background-color: var(--color-base-1);
  border-bottom: 1px solid var(--color-divider);

  ${mediaQuery.uptoMobile} {
    border-bottom: 8px solid var(--color-base-light-0);
  }
`;

const PageInner = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  left: ${Spacings.SPACING_50B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    left: 0;
  }
`;

const BackRow = styled.div`
  display: flex;
  align-items: center;
  padding: ${Spacings.SPACING_2B} 0;
`;

const Title = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H2};
  line-height: 38px;
  color: var(--color-text-primary);
  padding-bottom: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H3};
    line-height: 30px;
    padding: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
  }
`;

const FormArea = styled.div`
  width: 100%;
  padding: ${Spacings.SPACING_10B} 0 ${Spacings.SPACING_12B};
  display: flex;
  justify-content: center;

  ${mediaQuery.uptoMobile} {
    padding: 0 0 ${Spacings.SPACING_10B};
  }
`;

const FormCard = styled.div`
  width: 655px;
  max-width: calc(100% - ${Spacings.SPACING_8B});
  flex-shrink: 0;
  box-sizing: border-box;
  background-color: var(--color-base-1);
  border: 1px solid var(--color-divider);
  border-radius: 12px;
  padding: ${Spacings.SPACING_8B};
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_9B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    max-width: 100%;
    border: none;
    border-radius: 0;
    padding: ${Spacings.SPACING_4B};
    gap: 0;
  }
`;

const CbtVenueSelectionScreen = ({
  onBack,
  onProceed,
  getSegmentProps,
  programmeUid
}) => {
  const isMobile = useIsMobile();
  const { query } = useRouter();
  const resolvedProgrammeUid = programmeUid ?? query.courseUID;

  return (
    <PageWrapper>
      <HeaderBand>
        <PageInner>
          <BackRow>
            <IconButton variant="ghost" onClick={onBack}>
              <LeftChevron width={24} height={24} />
            </IconButton>
          </BackRow>
          <Title variant="h2">Fill your details</Title>
        </PageInner>
      </HeaderBand>
      <FormArea>
        <FormCard>
          <CbtVenueSelectionForm
            programmeUid={resolvedProgrammeUid}
            isMobile={isMobile}
            onProceed={onProceed}
            getSegmentProps={getSegmentProps}
          />
        </FormCard>
      </FormArea>
    </PageWrapper>
  );
};

export default CbtVenueSelectionScreen;
